import { OperationType } from "@/types/dataset";

// Error message mappings for failed operations
const ERROR_MESSAGE_MAP: {
  keyword: string;
  title: string;
  description: string;
}[] = [
  {
    keyword: "insufficient storage capacity",
    title: "Upload Failed",
    description:
      "File size exceeds your available quota. Please delete existing datasets or upgrade your plan"
  },
  {
    keyword: "invalid JSON format",
    title: "Invalid File Format",
    description:
      "Invalid JSON format. Please check for missing commas or brackets."
  },
  {
    keyword: "GeoJSON must be a FeatureCollection",
    title: "Invalid Structure",
    description: "GeoJSON must be a FeatureCollection."
  },
  {
    keyword: "type can't be null or empty",
    title: "Parsing Failed",
    description: "Field type cannot be null or empty."
  },
  {
    keyword: "missing required field: type",
    title: "Invalid Structure",
    description: "Feature is missing required field: type."
  },
  {
    keyword: "missing required field: properties",
    title: "Invalid Structure",
    description: "Feature is missing required field: properties."
  },
  {
    keyword: "missing required field: geometry",
    title: "Invalid Structure",
    description: "Feature is missing required field: geometry."
  }
];

// Default error notification for unmatched errors
const DEFAULT_ERROR = {
  title: "Something Went Wrong",
  description:
    "Sorry, we’re experiencing an issue while processing your request. Please try again."
};

// Import operation fallback error
const IMPORT_OPERATION_ERROR = {
  title: "Data Format Mismatch",
  description:
    "Please ensure your file uses the same structure as the existing dataset"
};

export const getErrorNotification = (
  errorMessage: string | undefined,
  operationType: OperationType
): { title: string; description: string } => {
  // Match against known error message keywords
  const matched = ERROR_MESSAGE_MAP.find(({ keyword }) =>
    errorMessage?.includes(keyword)
  );

  if (matched) {
    return { title: matched.title, description: matched.description };
  }

  // Fallback for import operations
  if (
    operationType === OperationType.IMPORT_ADD ||
    operationType === OperationType.IMPORT_REPLACE
  ) {
    return IMPORT_OPERATION_ERROR;
  }

  // Default fallback
  return DEFAULT_ERROR;
};
